export const menu = {
  namespaced: true,
  state: {
    showMenuName: '',
  },
  mutations: {
    toggleMenu(state, payload) {
      state.showMenuName = payload
    }
  },
  actions: {
    toggleMenu({ commit }, payload) {
      commit('toggleMenu', payload)
    },
    initMenu({ commit }, payload) {
      if (payload === 'location/stores') {
        commit('toggleMenu', 'locationStore')
      } else if (payload === 'location/benefits') {
        commit('toggleMenu', 'benefits')
      } else if (payload === 'reviews'
        || payload === 'photos'
        || payload === 'surveys'
      ) {
        commit('toggleMenu', 'monitoring')
      } else if (payload === 'posts') {
        commit('toggleMenu', 'operation')
      } else if (payload === 'analysis/insight'
        || payload === 'analysis/reviews'
        || payload === 'analysis/visitors'
        || payload === 'analysis/keywords'
        || payload === 'analysis/surveys'
      ) {
        commit('toggleMenu', 'analysis')
      } else if (payload === 'visitor/stores'
        || payload === 'survey_templates'
      ) {
        commit('toggleMenu', 'visitorStore')
      }
    }
  }
}
